/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  FETCH_PAYMENTS_REQUEST,
  FETCH_PAYMENTS_FAILURE,
  FETCH_PAYMENTS_SUCCESS,
  PAYMENT_METHODS_ADD,
  PAYMENT_METHODS_DELETE,
  PAYMENT_METHODS_FAILURE_UPDATE,
  PAYMENT_METHODS_UPDATE,
  PAYMENT_METHODS_MAKE_DEFAULT,
  PAYMENT_METHODS_RESET,
  PAYMENT_METHODS_RESET_ERROR,
  PAYMENT_METHODS_ADDED_TO_WALKIN_REQUEST
} from 'store/types/paymentMethods';
import { PaymentMethod, PaymentServices } from 'types';
import { ThunkAction } from 'redux-thunk';
import { State } from 'store/reducers/paymentMethods.reducer';
import { api2 } from '../apis'

export const requestPayments = () => ({
  type: FETCH_PAYMENTS_REQUEST,
});

export const receivePayments = (data: PaymentMethod[]) => ({
  type: FETCH_PAYMENTS_SUCCESS,
  preload: data,
});

export const failureRequest = (error: string) => ({
  type: FETCH_PAYMENTS_FAILURE,
  error,
});

export const addLocalPayment = () => ({
  type: PAYMENT_METHODS_ADD,
});

export const updatePayments = () => ({
  type: PAYMENT_METHODS_UPDATE,
});

export const failureUpdate = (error: string) => ({
  type: PAYMENT_METHODS_FAILURE_UPDATE,
  error,
});

export const deleteLocalPayment = (id: string) => ({
  type: PAYMENT_METHODS_DELETE,
  id,
});

export const makeDefaultPayment = (cardId: string, defaultCard: boolean) => ({
  type: PAYMENT_METHODS_MAKE_DEFAULT,
  cardId, defaultCard
});

export const resetPaymentMethods = () => ({ type: PAYMENT_METHODS_RESET })
export const resetPaymentMethodError = () => ({ type: PAYMENT_METHODS_RESET_ERROR })
export const paymentMethodsAddedToWalkinRequest = () => ({ type: PAYMENT_METHODS_ADDED_TO_WALKIN_REQUEST })

export type Actions =
  | ReturnType<typeof requestPayments>
  | ReturnType<typeof receivePayments>
  | ReturnType<typeof failureRequest>
  | ReturnType<typeof addLocalPayment>
  | ReturnType<typeof updatePayments>
  | ReturnType<typeof deleteLocalPayment>
  | ReturnType<typeof makeDefaultPayment>
  | ReturnType<typeof resetPaymentMethods>
  | ReturnType<typeof resetPaymentMethodError>
  | ReturnType<typeof failureUpdate>
  | ReturnType<typeof paymentMethodsAddedToWalkinRequest>;

type ThunkResult<R> = ThunkAction<R, State, undefined, Actions>;

export const paymentsFetch = (callback?: () => void): ThunkResult<void> => async dispatch => {
  dispatch(requestPayments());

  api2
    .get('/api/v2/patient/cards')(dispatch)
    .then(res => {
      let { cards } = res
      if (cards?.length === 1) cards[0].is_default = true
      dispatch(receivePayments(cards));
      callback && callback()
    })
    .catch(error => dispatch(failureRequest(error)));
};

export const deletePayment = (id: string): ThunkResult<void> => async dispatch => {
  dispatch(updatePayments());

  api2.delete('/api/v2/patient/cards', { card_id: id })(dispatch)
    .then(res => {
      dispatch(deleteLocalPayment(id));
    })
    .catch(error => {
      dispatch(failureUpdate(error.message))
    });
};

export const addNewPayment = (data: any, callback?: (err: any, res: any) => void): ThunkResult<void> => async dispatch => {
  dispatch(updatePayments());

  api2.post('/api/v2/patient/cards', data)(dispatch)
    .then(res => {
      callback && callback(null, res)
      dispatch(addLocalPayment());
      dispatch(paymentsFetch())
    })
    .catch(error => {
      callback && callback(error.message, null)
      dispatch(failureUpdate(error.message))
    });
};

export const paymentInitialsFetch = (custodianId: number, isForm: boolean = false, payload: any, callback: (data: PaymentServices) => void): ThunkResult<void> => async dispatch => {
  api2
    .post(`/api/v2/custodians/${custodianId}/get_record_service_charge?is_form=${isForm}`, payload, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })(dispatch)
    .then(res => {
      let price = parseFloat(res[isForm ? 'form_completion' : 'archieve_record_service'][0]?.price || 0)
      let data: PaymentServices = {
        instantDownload: parseFloat(res.record_deliver_services?.find((item: any) => item.key === 'instant_download')?.price || 0),
        faxReturn: parseFloat(res.record_deliver_services?.find((item: any) => item.key === 'fax_return')?.price || 0),
        rushRequest: parseFloat(res.rush_request_service?.find((item: any) => item.key === 'rush_request')?.price || 0),
        retrievalService: parseFloat(res.record_deliver_services?.find((item: any) => item.key === 'retrieval_service')?.price || 0),
        freeDelivery: parseFloat(res.record_deliver_services?.find((item: any) => item.key === 'free_delivery')?.price || 0)
      }
      if (isForm) data.formCompletion = price
      else data.archieveRecordService = price
      callback(data)
    })
    .catch(error => null);
};

export const makeCardDefault = (cardId: string, defaultCard: boolean): ThunkResult<void> => dispatch => {
  dispatch(updatePayments())
  api2.get('/api/v2/patient/cards/update_default_card_detail', {
    params: {
      card_id: cardId,
      default: defaultCard
    }
  })(dispatch)
    .then(res => dispatch(makeDefaultPayment(cardId, defaultCard)))
    .catch(error => dispatch(failureUpdate(error.message)));
}

export const addCardToWalkinRequestCrad = (data: any): ThunkResult<void> => async dispatch => {
  dispatch(updatePayments());

  api2.post('/api/v2/patient/cards/add_card_to_walkin_request_card', data)(dispatch)
    .then(res => {
      dispatch(paymentMethodsAddedToWalkinRequest())
    })
    .catch(error => {
      dispatch(failureUpdate(error.message))
    });
};

export const sendSnapshot = (base64: string, page: string, detail?: string, requestId?: string, custodian: Array<string> | null = null, remember_me = false, pm_id: string | null = null ): ThunkResult<void> => (dispatch, getState: () => any) => {
  let { profile } = getState().auth
  let fd = new FormData()
  if (detail) fd.append('detail', detail)
  if (requestId) fd.append('request_id', requestId)
  fd.append('file_name', `${page}_${profile?.name}_${new Date().valueOf()}.png`)
  fd.append('image', base64)
  if (custodian && custodian.length > 0) {
    custodian.forEach((custodianId) => {
      fd.append('custodian_id[]', custodianId);
    });
  }
  if (remember_me) {
    fd.append('remember_me', String(remember_me));
  }
  if (pm_id) {
    fd.append('card_id', pm_id);
  }

  api2.post('/api/v2/payments/store_screen_shot', fd)(dispatch)
    .then(res => null)
    .catch(error => null);
}